import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import hideOverlays from "core-web/state/models/Overlay/dispatches/hideOverlays";
import scrollFunctions from "core-web/utils/scrollFunctions";
import styled from "theme/libs/styled";
import toggleMenu from "core-web/state/models/Header/dispatches/toggleMenu";
import toggleSearch from "core-web/state/models/Header/dispatches/toggleSearch";
import transitions from "theme/config/transitions";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";

export const Wrapper = styled("div")`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: ${({ zIndex }) => zIndex};

    .slide-in--top,
    .slide-in--left,
    .slide-in--right,
    .slide-in--bottom {
        transition: transform ${transitions.primary};
    }
    &.entering,
    &.exited,
    &.exiting {
        .slide-in--top {
            transform: translate3d(0, -100%, 0);
        }
        .slide-in--left {
            transform: translate3d(-100%, 0, 0);
        }
        .slide-in--right {
            transform: translate3d(100%, 0, 0);
        }
        .slide-in--bottom {
            transform: translateY(100%);
        }
        .fade {
            opacity: 0;
        }
    }

    &.entered {
        .slide-in--top,
        .slide-in--left,
        .slide-in--right {
            transform: translate3d(0, 0, 0);
        }

        .fade {
            opacity: 1;
        }
    }
`;

const Background = styled("div")`
    position: absolute;
    inset: 0;
    background: rgba(40, 40, 40, 0.2);
    transition: all ${({ duration }) => duration}ms linear;
`;

const OverlayWrapper = ({ children, className, duration, location, zIndex, isInCheckout }) => {
    const [prevLocation, setPrevLocation] = useState(location);
    const { menuIsOpen, searchIsOpen } = useSelector(({ header }) => header.states) || {};

    useEffect(() => {
        scrollFunctions.preventScroll();

        return () => {
            scrollFunctions.allowScroll();
        };
    }, []);

    useEffect(() => {
        if (location && prevLocation && location.pathname !== prevLocation.pathname) {
            setPrevLocation(null);
            hideOverlays();
        } else {
            setPrevLocation(location);
        }
    }, [location]);

    const closeOverlay = () => {
        hideOverlays({ isInCheckout });

        if (searchIsOpen) {
            toggleSearch(false);
        }

        if (menuIsOpen) {
            toggleMenu(false);
        }
    };

    return (
        <Wrapper zIndex={zIndex} className={className} duration={duration}>
            <Background className="fade" duration={duration} onClick={closeOverlay} />
            {children}
        </Wrapper>
    );
};

OverlayWrapper.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string.isRequired,
    duration: PropTypes.number.isRequired,
    isInCheckout: PropTypes.bool,
    location: PropTypes.object.isRequired,
    zIndex: PropTypes.number,
};

OverlayWrapper.defaultProps = {
    children: null,
    isInCheckout: false,
    zIndex: 9998,
};

export default withRouter(OverlayWrapper);
